export default "__VITE_ASSET__Bp_Ahp5O__"